import { ModuleBase } from "@/modules/base";
import { IView } from "@/store/frame";
import { Component, Mixins } from 'vue-property-decorator';
import AddBookmarkWindow from "./AddBookmarkWindow/index.vue";
import EditBookmarksWindow from "./EditBookmarksWindow/index.vue";
import Menu from './Menu/index.vue';
import WalkSettingWindow from "./WalkSettingWindow.vue";
import { fileDialog, readFileAsText, downloadJson } from "@/utils/file";
import * as easing from '@hscmap/easing'
import { recommendedBookmarks } from "./recommendedBookmarks";

@Component
export class BookmarkModule extends Mixins(ModuleBase) {
  showAddBookmark = false
  showEditBookmarks = false
  showWalkSetting = false
  walking = false

  persistent = {
    root: newBookmarkFolder('$root'),
    config: {
      walk: {
        duration: 4000,
        easing: 'slowStartStop4' as keyof typeof easing,
        keepFovy: false,
        wait: 1000,
        loop: true,
      },
    },
  }

  get root() {
    return this.persistent.root
  }

  get config() {
    return this.persistent.config
  }

  recommendedBookmarks(locale: string) {
    return recommendedBookmarks(locale)
  }

  async importJson(e: Event) {
    const files = await fileDialog().catch(() => null)
    if (files && files.length > 0) {
      const file = files.item(0)!
      const json = await readFileAsText(file)
      try {
        const root = JSON.parse(json) as IBookmarkFolder
        const name = prompt(`New folder name ?`, file.name)
        if (name) {
          root.name = name
          this.root.children.push(root)
        }
      } catch (e) {
        alert(`Import error: ${e}, json=${json}`)
      }
    }
  }

  exportJson() {
    downloadJson('hscMap-Bookmark.json', this.root)
  }

  importFromHscMap2() {
    const json = prompt('Bookmarks exported by hscMap2 ?')
    if (json) {
      try {
        const newRoot = convertBookmarksFromHscMap2(json)
        this.root.children.push(newRoot)
      } catch (e) {
        alert(`Failed to import bookmarks.\n${e}`)
      }
    }
  }

  get outlet() {
    return {
      bookmarkMenu: Menu,
      window: [AddBookmarkWindow, EditBookmarksWindow, WalkSettingWindow],
    }
  }

  created() {
    this.$nextTick(() => this.migrateFromHscMap4())
  }

  private migrateFromHscMap4() {
    const KEY = '@hscmap/hscmap/4/bookmarks'
    const json = localStorage.getItem(KEY)
    if (json) {
      try {
        const root = JSON.parse(json)
        this.persistent.root = root
        localStorage.removeItem(KEY)
      } catch (e) {
        console.error(e)
      }
    }
  }
}

export function foldersIn(folder: IBookmarkFolder, exclude?: BookmarkEntry, prefix = '/') {
  const bfp: IBookmarkFolderPath[] = [{ path: prefix, folder }]
  for (const e of folder.children) {
    if (e.isFolder && e !== exclude) {
      bfp.push(...foldersIn(e, exclude, `${prefix}${e.name}/`))
    }
  }
  return bfp
}

export interface IBookmark {
  name: string
  view: IView
  isFolder: false
}

export interface IBookmarkFolder {
  name: string
  children: BookmarkEntry[]
  isFolder: true
}

export type BookmarkEntry = IBookmark | IBookmarkFolder
export interface IBookmarkFolderPath { path: string, folder: IBookmarkFolder }

export function newBookmark(name: string, view: IView): IBookmark {
  return { name, view, isFolder: false }
}

export function newBookmarkFolder(name: string, children: BookmarkEntry[] = []): IBookmarkFolder {
  return {
    name,
    children,
    isFolder: true,
  }
}

function convertBookmarksFromHscMap2(json: string) {
  const root = JSON.parse(json)
  const convert = (e: any) => {
    if (e.entries) {
      return newBookmarkFolder(e.name, e.entries.map((c: any) => convert(c)))
    } else {
      const { a, d, fovy, roll } = e
      return newBookmark(e.name, { a, d, fovy, roll })
    }
  }
  root.name = `imported from hscMap2`
  return convert(root)
}
